import {createContext, useEffect, useMemo, useState} from 'react';

const defaultContextValue = {
  activeObjects: [],
  setActiveObjects: () => {},
  activeSections: {
    design: true,
    gifting: false,
    details: false,
  },
  setActiveSections: () => null,
  showBackground: false,
  setShowBackground: () => {},
  showBottomNav: false,
  setShowBottomNav: () => {},
  canvas: null,
  setCanvas: () => null,
  inIsolatedEditMode: false,
  setInIsolatedEditMode: () => {},
};

export const FabricContext = createContext(defaultContextValue);

export const FabricContextParent = ({children}) => {
  const [canvas, setCanvas] = useState();
  const [activeSections, setActiveSections] = useState(defaultContextValue.activeSections);
  const [activeObjects, setActiveObjects] = useState();
  const [showBottomNav, setShowBottomNav] = useState(false);
  const [showBackground, setShowBackground] = useState(false);
  const [inIsolatedEditMode, setInIsolatedEditMode] = useState(false);

  useEffect(() => {
    setActiveSections({
      design: true,
      gifting: true,
      details: true,
    });
    setShowBottomNav(true);
  }, []);

  const context = useMemo(
    () => ({
      activeObjects,
      setActiveObjects,
      activeSections,
      setActiveSections,
      showBackground,
      setShowBackground,
      showBottomNav,
      setShowBottomNav,
      canvas,
      setCanvas,
      inIsolatedEditMode,
      setInIsolatedEditMode,
    }),
    [
      activeObjects,
      setActiveObjects,
      activeSections,
      setActiveSections,
      showBackground,
      setShowBackground,
      showBottomNav,
      setShowBottomNav,
      canvas,
      setCanvas,
      inIsolatedEditMode,
      setInIsolatedEditMode,
    ]
  );

  return <FabricContext.Provider value={context}>{children}</FabricContext.Provider>;
};
